export enum EStoriesActionTypes {
    SET_IS_LOADING = 'SET_IS_LOADING',
    SET_STORIES = 'SET_STORIES',
}
